module.exports = __webpack_public_path__ + "static/img/continue.6bc1065.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/continue.png
// module id = gKMn
// module chunks = 1